"use strict";
import { __module as a } from "./index.es293.js";
import { __require as _ } from "./index.es294.js";
import { __require as l } from "./index.es275.js";
var t;
function h() {
  return t ? a.exports : (t = 1, (function(u, e) {
    Object.defineProperty(e, "__esModule", {
      value: !0
    }), Object.defineProperty(e, "addBasePath", {
      enumerable: !0,
      get: function() {
        return f;
      }
    });
    const i = _(), d = l(), n = process.env.__NEXT_ROUTER_BASEPATH || "";
    function f(r, o) {
      return (0, d.normalizePathTrailingSlash)(process.env.__NEXT_MANUAL_CLIENT_BASE_PATH && !o ? r : (0, i.addPathPrefix)(r, n));
    }
    (typeof e.default == "function" || typeof e.default == "object" && e.default !== null) && typeof e.default.__esModule > "u" && (Object.defineProperty(e.default, "__esModule", { value: !0 }), Object.assign(e.default, e), u.exports = e.default);
  })(a, a.exports), a.exports);
}
export {
  h as __require
};
//# sourceMappingURL=index.es258.js.map
